<template>
  <div class="container row">
    <div class="card col-8">
      <form v-on:submit.prevent="submitEntry">
        <div class="row">
          <div class="col-sm-4">
            <label for="first_name" class="head">First Name</label>
          </div>
          <div class="col-sm-4">
            <input
              type="text"
              id="first_name"
              v-model="user.first_name"
              name="FirstName"
              class="box"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-sm-4">
            <label for="last_name" class="head">Last Name</label>
          </div>
          <div class="col-sm-4">
            <input
              type="text"
              id="last_name"
              v-model="user.last_name"
              name="LastName"
              class="box"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-sm-4">
            <label for="user_name" class="head">Username/Email</label>
          </div>
          <div class="col-sm-4">
            <input
              type="text"
              id="first_name"
              name="UserName"
              v-model="user.username"
              class="box"
              :disabled="noEditFlag"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-sm-4">
            <label for="pass" class="head">Password</label>
          </div>
          <div class="col-sm-4">
            <input
              type="password"
              id="pass"
              name="password"
              class="box"
              v-model="user.password"
              ref="passwordfield"
            />
            <span
              toggle="#password-field"
              class="field-icon peek-button"
              @mouseup="showPassword"
              @mousedown="showPassword"
            >
              <img
                src="@/assets/images/eye.svg"
                style="width:15px"
                alt="show"
              />
            </span>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-4">
            <label for="role" class="head">Role</label>
          </div>
          <div class="col-sm-4">
            <dropdown
              class="box"
              :defaultValue="user.role"
              style="border: none"
              :optionlist="roles"
              @select="RoleSelected"
            ></dropdown>
            <!-- <select class="box" v-model="user.role" style="width:309px;" @change="RoleSelected()">
              <option value selected hidden>Select One</option>
              <option
                v-for="item,index in roles"
                :key="index"
                :value="item.name"
              >{{toTitleCase(item.name)}}</option>
              <option value="guest">Guest</option>
            </select>-->
          </div>
        </div>
        <div class="row">
          <div class="col-sm-4">
            <label for="role" class="head">Group</label>
          </div>
          <div class="col-sm-4">
            <dropdown
              class="box"
              style="border: none"
              :optionlist="this.groups"
              :multiselect="true"
              :search="true"
              :removeditems="removedCmdGroup"
              @select="addGroup"
            ></dropdown>
            <br />
            <span v-if="user.cmdGroups.length == 0" class="added-tags-label"
              >No Groups Added</span
            >
            <span v-else class="added-tags-label">Added Groups</span>
            <div class="tag" v-for="tag in user.cmdGroups" style="width:309px">
              <div class="tag-name">{{ tag.name }}</div>
              <!-- splice is being used to remove the tag. make it a method if possible -->
              <div class="remove-tag" @click="removeGrp(tag)">Remove</div>
            </div>
          </div>
        </div>
        <!-- <div class="row">
          <div class="col-sm-4">
            <label for class="head">Send User Notification</label>
          </div>
          <div class="col-sm-4">
            <input type="checkbox" name="reminder" class="check_box" checked />
            <span class="sub_head">Send the new user an email about their account</span>
          </div>
        </div>-->
        <div class="row">
          <div class="col-sm-4"></div>
          <div class="col-sm-4 row justify-content-between">
            <button type="reset" @click="Cancel" class="btn">Cancel</button>
            <button type="submit" class="btn">{{ user.id ? 'Update' : 'Save' }}</button>
          </div>
        </div>
      </form>
    </div>
    <div class="col-4">
      <div class="card-2">
        <div class="card-header">Role Permissions</div>
        <div class="card-body panel-group">
          <div class="panel panel-default">
            <div class="panel-heading">
              <h4 class="panel-title">
                <a
                  data-toggle="collapse"
                  class="sub_heading font_wei"
                  href="#collapse1"
                >
                  Analytics
                  <i class="fa fa-angle-right" v-if="$('#collapse1.show')"></i>
                  <i class="fa fa-angle-down" v-else></i>
                </a>
              </h4>
            </div>
            <div
              id="collapse1"
              ref="collapse1"
              class="panel-collapse collpase show"
            >
              <div class="form-check">
                <input
                  class="form-check-input check_box"
                  type="checkbox"
                  v-model="permissions.Analytics.canView"
                  id="Analytics_canView"
                  :disabled="user.role != '' && user.role != 'guest'"
                />
                <label class="form-check-label" for="Analytics_canView"
                  >View Analytics</label
                >
              </div>
            </div>
          </div>
          <div class="panel panel-default">
            <div class="panel-heading">
              <h4 class="panel-title">
                <a
                  data-toggle="collapse"
                  class="sub_heading font_wei"
                  href="#collapse2"
                >
                  Inspection
                  <i class="fa fa-angle-right" v-if="collapse2"></i>
                  <i class="fa fa-angle-down" v-else></i>
                </a>
              </h4>
            </div>
            <div
              id="collapse2"
              ref="collapse2"
              class="panel-collapse collpase show"
            >
              <div class="form-check">
                <input
                  class="form-check-input check_box"
                  type="checkbox"
                  v-model="permissions.Inspection.canView"
                  value
                  id="Inspection_canView"
                  :disabled="user.role != '' && user.role != 'guest'"
                />
                <label class="form-check-label" for="Inspection_canView"
                  >View Commodities</label
                >
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  v-model="permissions.Inspection.canCreate"
                  id="Inspection_cancreate"
                  :disabled="
                    !permissions.Inspection.canView ||
                      (user.role != '' && user.role != 'guest')
                  "
                />
                <label class="form-check-label" for="Inspection_cancreate"
                  >Create Report</label
                >
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  v-model="permissions.Inspection.canAutoApprove"
                  id="Inspection_canAutoApprove"
                  :disabled="
                    !permissions.Inspection.canView ||
                      (user.role != '' && user.role != 'guest')
                  "
                />
                <label class="form-check-label" for="Inspection_canAutoApprove"
                  >Auto Approve Report</label
                >
              </div>
            </div>
          </div>
          <div class="panel panel-default">
            <div class="panel-heading">
              <h4 class="panel-title">
                <a
                  data-toggle="collapse"
                  class="sub_heading font_wei"
                  href="#collapse3"
                >
                  Inspection Summary
                  <i class="fa fa-angle-right" v-if="collapse3"></i>
                  <i class="fa fa-angle-down" v-else></i>
                </a>
              </h4>
            </div>
            <div
              id="collapse3"
              ref="collapse3"
              class="panel-collapse collpase show"
            >
              <div class="form-check">
                <input
                  class="form-check-input check_box"
                  type="checkbox"
                  v-model="permissions.InspectionSummary.canView"
                  id="Summary_canView"
                  :disabled="user.role != '' && user.role != 'guest'"
                  @change="checked('InspectionSummary')"
                />
                <label class="form-check-label" for="Summary_canView"
                  >View Summary</label
                >
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  v-model="permissions.InspectionSummary.canViewAll"
                  id="Summary_canViewAll"
                  :disabled="
                    !permissions.InspectionSummary.canView ||
                      (user.role != '' && user.role != 'guest')
                  "
                />
                <label class="form-check-label" for="Summary_canViewAll"
                  >View Summary for All</label
                >
              </div>
              <!-- <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  v-model="permissions.InspectionSummary.canComment"
                  id="Summary_canComment"
                  :disabled="!permissions.InspectionSummary.canView || (user.role!='' && user.role!='guest')"
                />
                <label class="form-check-label" for="Summary_canComment">Add Comments</label>
              </div> -->
              <!-- <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  v-model="permissions.InspectionSummary.canEdit"
                  id="Summary_canEdit"
                  :disabled="!permissions.InspectionSummary.canView || (user.role!='' && user.role!='guest')"
                />
                <label class="form-check-label" for="Summary_canEdit">Edit Report</label>
              </div> -->
              <!-- <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  v-model="permissions.InspectionSummary.canApprove"
                  id="Summary_canApprove"
                  :disabled="!permissions.InspectionSummary.canView || (user.role!='' && user.role!='guest')"
                />
                <label class="form-check-label" for="Summary_canApprove">Approve Report</label>
              </div> -->
              <!-- <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  v-model="permissions.InspectionSummary.canDownload"
                  id="Summary_canDownload"
                  :disabled="!permissions.InspectionSummary.canView || (user.role!='' && user.role!='guest')"
                />
                <label class="form-check-label" for="Summary_canDownload">Download Report</label>
              </div> -->
            </div>
          </div>
          <div class="panel panel-default">
            <div class="panel-heading">
              <h4 class="panel-title">
                <a
                  data-toggle="collapse"
                  class="sub_heading font_wei"
                  href="#collapse4"
                >
                  Commodities
                  <i class="fa fa-angle-right" v-if="collapse4"></i>
                  <i class="fa fa-angle-down" v-else></i>
                </a>
              </h4>
            </div>
            <div
              id="collapse4"
              ref="collapse4"
              class="panel-collapse collpase show"
            >
              <!-- <div class="form-check">
                <input
                  class="form-check-input check_box"
                  type="checkbox"
                  v-model="permissions.Commodities.canView"
                  id="Commodities_canView"
                  :disabled="user.role!='' && user.role!='guest'"
                />
                <label class="form-check-label" for="Commodities_canView">View Commodities</label>
              </div> -->
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  v-model="permissions.Commodities.canViewAllCommodities"
                  id="Commoditiess_canViewAll"
                  :disabled="
                    !permissions.Commodities.canView ||
                      (user.role != '' && user.role != 'guest')
                  "
                />
                <label class="form-check-label" for="Commoditiess_canViewAll"
                  >View All Commodities</label
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.col-sm-4 > input {
  padding: 2px 10px;
}
.panel-title {
  margin-top: 0.5rem;
  margin-bottom: 0;
  font-weight: bolder;
}
.box {
  background: #ffffff;
  mix-blend-mode: normal;
  border: 1px solid #b4b4b4;
  box-sizing: border-box;
  border-radius: 4px;
  width: 309px;
  height: 38px;
}
.head {
  font-family: Source Sans Pro;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 18px;
  margin-top: 1rem;
  margin-bottom: auto;
  /* identical to box height */

  color: #29342e;
}
.sub_head {
  font-family: Source Sans Pro;
  font-style: normal;
  font-weight: 300;
  font-size: 14px;
  line-height: 18px;
  margin-left: 12px;

  color: #29342e;
}
.form-check-input:disabled ~ .form-check-label {
  color: #a5a5a5;
}
.btn {
  background: #24c656;
  border-radius: 4px;
  width: 92px;
  height: 38px;
  color: white;
  margin-right: 0px;
}
.row {
  margin-bottom: 32px;
}
.card {
  background: #ffffff;
  box-shadow: 0px 2px 20px rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  padding: 40px;
}

.card-2 {
  background: #ffffff;
  box-shadow: 0px 2px 20px rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  /* padding: 40px; */
}
input[type="text"]:focus {
  background: #ffffff;
  mix-blend-mode: normal;
  border: 1px solid #24c656;
  box-sizing: border-box;
  border-radius: 4px;
}
input[type="password"]:focus {
  background: #ffffff;
  mix-blend-mode: normal;
  border: 1px solid #24c656;
  box-sizing: border-box;
  border-radius: 4px;
}
.check_box {
  background: #ffffff;
  border: 1px solid #b4b4b4;
  box-sizing: border-box;
  border-radius: 4px;
  color: white;
}

.peek-button {
  position: absolute;
  left: 297px;
  top: 9px;
  color: #24c756;
  cursor: pointer;
}

.card2 {
  background: #ffffff;
  box-shadow: 0px 2px 20px rgba(0, 0, 0, 0.15);
  border-bottom-right-radius: 4px;
  border-bottom-left-radius: 4px;
  padding-top: 19px;
  padding-bottom: 19px;
  padding-left: 12px;
  padding-right: 9px;
}

.sub_heading {
  font-family: Source Sans Pro;
  font-style: normal;
  font-weight: bolder;
  font-size: 14px;
  line-height: 18px;
  color: #2c3e50;
}
.added-tags-label {
  font-size: 14px;
  margin-top: 50px;
  color: #29342e;
}

.tag-list {
  background: #fff;
}

.tag {
  height: 20px;
  margin: 10px 0px 0px 0px;
}

.tag-name {
  width: 75%;
  display: inline-block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  height: 100%;
  font-size: 12px;
  color: #646464;
}

.remove-tag {
  width: 20%;
  margin-left: 1%;
  border: 1px solid #e74c3c;
  color: #e74c3c;
  font-size: 10px;
  border-radius: 4px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  float: right;
  cursor: default;
}
</style>
<script>
import dropdown from "@/components/dropdown/dropdown.vue";
const _ = require("lodash");

export default {
  name: "EditUser",
  components: {
    dropdown
  },
  data() {
    return {
      passwordFocus: false,
      permissions: {
        Analytics: {
          canView: false
        },
        Inspection: {
          canView: false,
          canCreate: false,
          canAutoApprove: false
        },
        InspectionSummary: {
          canView: false,
          canViewAll: false,
          canComment: false,
          canApprove: false,
          canEdit: false,
          canDownload: false
        },
        Commodities: {
          canView: false,
          canViewAllCommodities: false
        }
      },
      user: {
        id: "",
        first_name: "",
        last_name: "",
        username: "",
        password: "",
        role: "",
        cmdGroup: {},
        cmdGroups: []
      },
      reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/
      //decides the vue to be displayed (login, forgot password, success)
    };
  },
  computed: {
    $() {
      return $;
    },
    groups() {
      return this.$store.state.commGroups;
    },
    roles() {
      return this.$store.state.aclGroups;
    },
    removedCmdGroup() {
      return this.groups.filter(item => {
        for (let index in this.user.cmdGroups) {
          let elem = this.user.cmdGroups[index];
          if (item._id.$oid == elem.id) {
            return true;
          }
        }
        return false;
      });
    },
    noEditFlag() {
      return this.$route.path.includes("/edit");
    },
    activeUser() {
      return this.$store.state.activeUser;
    },
    collapse2() {
      if (this.$refs.collapse2)
        return [...this.$refs.collapse2.classList].includes("show");
      return [].includes("show");
    },
    collapse3() {
      if (this.$refs.collapse3)
        return [...this.$refs.collapse3.classList].includes("show");
      return [].includes("show");
    },
    collapse4() {
      if (this.$refs.collapse4)
        return [...this.$refs.collapse4.classList].includes("show");
      return [].includes("show");
    }
  },
  watch: {},
  methods: {
    showPassword() {
      // shows the password on mouse up
      if (this.$refs.passwordfield.getAttribute("type") == "password") {
        this.$refs.passwordfield.setAttribute("type", "text");
      } else {
        this.$refs.passwordfield.setAttribute("type", "password");
      }
    },
    validEmail() {
      return this.reg.test(this.user.username);
    },
    async addGroup(obj) {
      // var item = {
      //   name: obj.option.name,
      //   id: obj.option._id.$oid
      // };
      var include = false;
      await this.user.cmdGroups.forEach(grp => {
        if (grp.id == obj.option._id.$oid) include = true;
      });
      if (!include) {
        this.user.cmdGroups.push({
          name: obj.option.name,
          id: obj.option._id.$oid
        });
      }
    },
    checked(section) {
      //executed when a section is checked
      // console.log(this.$refs.collapse2.classList.contains("show"));
      if (!this.permissions[section].canView) {
        var arr = Object.keys(this.permissions[section]);
        arr.forEach(obj => {
          this.permissions[section][obj] = false;
        });
      }
    },
    RoleSelected(e) {
      //executed when a role is selected

      this.user.role = e.option.name;
      var role = this.user.role;
      if (role != "" && role != "guest") {
        var that = this;
        this.roles.filter(function(data) {
          if (data.name == role) that.permissions = data.permissions;
        });
      } else
        this.permissions = {
          Analytics: {
            canView: false
          },
          Inspection: {
            canView: false,
            canCreate: false,
            canAutoApprove: false
          },
          InspectionSummary: {
            canView: false,
            canViewAll: false,
            canComment: false,
            canApprove: false,
            canEdit: false,
            canDownload: false
          },
          Commodities: {
            canView: false,
            canViewAllCommodities: false
          }
        };
    },
    toTitleCase(str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    },
    removeGrp(tag) {
      this.user.cmdGroups = this.user.cmdGroups.filter(grp => {
        // if (tag.id) return grp.id != tag.id;
        return grp.id != tag.id;
      });
    },
    createLogData(obj, mode) {
      var user = _.cloneDeep(obj);
      var keys = [],
        oldValue = [],
        newValue = [];
      var LogData = {};
      if (mode == "edit") {
        var permissions = obj.permissions;
        delete user.permissions;
        for (let key in user) {
          // if()

          if (key in this.activeUser) {
            if (user[key] != this.activeUser[key]) {
              newValue.push(user[key]);
              oldValue.push(this.activeUser[key]);
              keys.push(key);
            } else {
              newValue.push(user[key]);
              oldValue.push("");
              keys.push(key);
            }
          }
        }
        // console.log(permissions == this.activeUser.permissions);

        if (permissions != this.activeUser.permissions) {
          for (let key in permissions) {
            // if (permissions[key] != this.activeUser.permissions[key]) {
            //   keys.push(`permissions["${key}"]`);
            //   newValue.push(permissions[key]);
            //   oldValue.push(this.activeUser.permissions[key]);
            // }
            for (let permission in permissions[key]) {
              if (
                permissions[key][permission] !=
                this.activeUser.permissions[key][permission]
              ) {
                keys.push(`${key}.${permission}`);
                newValue.push(permissions[key][permission]);
                oldValue.push(this.activeUser.permissions[key][permission]);
              }
            }
          }
        }
        LogData = {
          user: this.$store.state.user,
          collection: "user",
          mode: "edit",
          record: user.id,
          fields: keys,
          newValue,
          oldValue
        };
      } else if (mode == "create") {
        delete user.id;
        delete user.permissions;
        for (let key in user) {
          newValue.push(user[key]);
          // oldValue.push(null);
          keys.push(key);
        }
        keys.push("permissions");
        newValue.push(obj.permissions);
        // keys.push(S)
        LogData = {
          user: this.$store.state.user,
          collection: "user",
          mode: "create",
          fields: keys,
          newValue,
          oldValue: []
        };
      }
      // console.log(x`LogData);

      return LogData;
    },
    submitEntry(e) {
      if (
        this.user.first_name == "" ||
        this.user.last_name == "" ||
        this.user.username == "" ||
        this.user.role == ""
      ) {
        this.$store.dispatch("showSnackbar", {
          msg: "First Name, Last Name, UserName and Role are required fields!"
        });
        return;
      }
      if (this.user.password == "" && !this.noEditFlag) {
        this.$store.dispatch("showSnackbar", { msg: "Password is required!" });
        return;
      }
      var user = {
        ...this.user,
        permissions: this.permissions,
        cmdGroups: this.user.cmdGroups.map(obj => obj.id)
      };
      if (this.noEditFlag) {
        if (user.password == "") delete user.password;
        var logData = this.createLogData(user, "edit");
        delete user.id;

        var that = this;
        this.$store
          .dispatch("updateUser", { id: this.user.id, user })
          .then(async msg => {
            await that.$store.dispatch("AddUserLog", logData);
            that.$store.dispatch("showSnackbar", { msg: "Updated" });
            that.$router.push("/app/secure/admincenter/users");
          });
      } else {
        if (!this.validEmail()) {
          this.$store.dispatch("showSnackbar", {
            msg: "UserName must a valid Email!"
          });
          return;
        }
        var logData = this.createLogData(user, "create");
        var that = this;
        delete user.id;
        this.$store
          .dispatch("addUser", user)
          .then(async result => {
            logData.record = result;
            await that.$store.dispatch("AddUserLog", logData);
            that.$router.push("/app/secure/admincenter/users");
          })
          .catch(err => {
            this.user = {
              id: "",
              first_name: "",
              last_name: "",
              username: "",
              password: "",
              role: "",
              cmdGroup: "",
              cmdGroups: []
            };
          });
      }
      // user.role = user.role.toLowerCase();
    },
    Cancel(e) {
      this.$router.push("/app/secure/admincenter/users");
    }
  },
  mounted() {
    this.$store.dispatch("showLoader", false);
  },
  async created() {
    await this.$store.dispatch("getACLGroup");
    await this.$store.dispatch("getCGroups");
    this.groups;
    if (this.noEditFlag) {
      this.user.id = this.$route.params.userId;
      await this.$store.dispatch("getUser", this.user.id);
      this.user = {
        id: this.user.id,
        first_name: this.activeUser.first_name,
        last_name: this.activeUser.last_name,
        username: this.activeUser.username,
        role: this.activeUser.role,
        // cmdGroup: this.activeUser.cmdGroup ? this.activeUser.cmdGroup.$oid : [],
        cmdGroups: this.activeUser.cmdGroups ? this.activeUser.cmdGroups : []
      };
      this.permissions = this.activeUser.permissions;
      this.$store.commit("changePathLabel", {
        view: "Configure User",
        categories: [{ name: "Edit User", focus: true }]
      });
    } else {
      this.$store.commit("changePathLabel", {
        view: "Configure User",
        categories: [{ name: "Create User", focus: true }]
      });
    }
  }
};
</script>
